import React, { useState, useEffect } from 'react';
import { useRef } from 'react';
import { ArrowRight, Globe, Handshake, Star, TrendingUp } from 'lucide-react';

import img1 from '../components/images/suppliers/crosspoint.png'
import img2 from '../components/images/suppliers/leadtech.png'
import img3 from '../components/images/suppliers/zartij.jpg'
import img4 from '../components/images/suppliers/savema.png'
import img5 from '../components/images/suppliers/dibal.jpg'
import img6 from '../components/images/suppliers/honeywell.png'
import img7 from '../components/images/suppliers/zebra.png'
import img8 from '../components/images/suppliers/rongta.png'
import img9 from '../components/images/suppliers/sunmi.png'
import img10 from '../components/images/suppliers/hanshow.png'


const partners1 = [
  { id: 1, name: 'Cross Point', logo: img1 },
  { id: 2, name: 'Lead Tech', logo: img2 },
  { id: 3, name: 'Zar-TIJ', logo: img3 },
  { id: 4, name: 'Savema', logo: img4 },
  { id: 5, name: 'Dibal', logo: img5},
  { id: 6, name: 'Honeywell', logo: img6 },
  { id: 7, name: 'Zebra', logo: img7 },
  { id: 8, name: 'Rongta', logo: img8 },
 
  { id: 9, name: 'Sunmi', logo: img9 },
  {id:10, name:'Hanshow', logo: img10},
];

export default function PartnersSection() {
  const [hoveredPartner, setHoveredPartner] = useState(null);
  const [currentSlide, setCurrentSlide] = useState(0);


const scrollRef = useRef(null);
  const [animationSpeed, setAnimationSpeed] = useState(1);

  // Function to handle marquee animation
  useEffect(() => {
    const marqueeElement = scrollRef.current;
    if (!marqueeElement) return;

    let scrollAmount = 0;
    let scrollDirection = 1;
    
    const animate = () => {
      scrollAmount += 0.5 * animationSpeed * scrollDirection;
      marqueeElement.style.transform = `translateX(${-scrollAmount}px)`;
      
      // Check if we need to reset the scroll position
      const maxScroll = marqueeElement.scrollWidth / 2;
      if (scrollAmount >= maxScroll) {
        scrollAmount = 0;
      }
      
      requestAnimationFrame(animate);
    };
    
    const animationId = requestAnimationFrame(animate);
    
    return () => cancelAnimationFrame(animationId);
  }, [animationSpeed]);

  // Double the partners for seamless infinite scrolling
  const doubledPartners = [...partners1, ...partners1];





  // Sample partner data - replace with your actual partners
  const partners = [
    {
      name: "Microsoft",
      category: "Technology",
      logo: "MS",
      gradient: "from-blue-600 to-cyan-500",
      description: "Strategic technology partnership for enterprise solutions"
    },
    {
      name: "Amazon",
      category: "Cloud Services",
      logo: "AM",
      gradient: "from-orange-500 to-yellow-500",
      description: "Cloud infrastructure and logistics solutions"
    },
    {
      name: "Samsung",
      category: "Hardware",
      logo: "SM",
      gradient: "from-blue-800 to-blue-600",
      description: "Advanced display and printing technology"
    },
    {
      name: "Zebra Technologies",
      category: "Industrial",
      logo: "ZT",
      gradient: "from-gray-800 to-gray-600",
      description: "Industrial printing and barcode solutions"
    },
    {
      name: "Honeywell",
      category: "Manufacturing",
      logo: "HW",
      gradient: "from-red-600 to-red-800",
      description: "Industrial automation and safety systems"
    },
    {
      name: "Intel",
      category: "Computing",
      logo: "IN",
      gradient: "from-blue-700 to-indigo-800",
      description: "Processing power for retail and industrial systems"
    },
    {
      name: "Cisco",
      category: "Networking",
      logo: "CS",
      gradient: "from-blue-500 to-teal-600",
      description: "Network infrastructure and connectivity solutions"
    },
    {
      name: "Oracle",
      category: "Database",
      logo: "OR",
      gradient: "from-red-500 to-red-700",
      description: "Enterprise database and cloud applications"
    },
    {
      name: "IBM",
      category: "Enterprise",
      logo: "IBM",
      gradient: "from-blue-900 to-gray-800",
      description: "AI and enterprise computing solutions"
    },
    {
      name: "Google",
      category: "Cloud & AI",
      logo: "GO",
      gradient: "from-green-500 to-blue-600",
      description: "Cloud computing and artificial intelligence"
    },
    {
      name: "Adobe",
      category: "Software",
      logo: "AD",
      gradient: "from-red-600 to-pink-600",
      description: "Creative and document management solutions"
    },
    {
      name: "Salesforce",
      category: "CRM",
      logo: "SF",
      gradient: "from-blue-400 to-cyan-500",
      description: "Customer relationship management platform"
    }
  ];

  // Auto-scroll effect for the moving banner
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % Math.ceil(partners.length / 4));
    }, 3000);
    return () => clearInterval(interval);
  }, [partners.length]);

  const stats = [
    { icon: Globe, number: "10+", label: "Countries Served", color: "text-blue-600" },
    { icon: Handshake, number: "25+", label: "Trusted Brands", color: "text-emerald-600" },
    { icon: Star, number: "Top-10", label: "Industry Leaders", color: "text-amber-600" },
    { icon: TrendingUp, number: "1M+", label: "Products Distributed", color: "text-purple-600" }
  ];

  return (
    <section className="py-20 bg-gradient-to-br from-white to-gray-50 relative overflow-hidden">
      {/* Background decorations */}
      <div className="absolute inset-0">
        <div className="absolute top-1/4 left-1/4 w-64 h-64 bg-blue-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30 animate-pulse"></div>
        <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-purple-100 rounded-full mix-blend-multiply filter blur-3xl opacity-25 animate-pulse delay-1000"></div>
        <div className="absolute top-3/4 left-1/2 w-72 h-72 bg-emerald-100 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-pulse delay-2000"></div>
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold bg-gradient-to-r from-gray-900 via-blue-900 to-purple-900 bg-clip-text text-transparent mb-6">
            The Brands Behind Us
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed mb-8 font-poppins">
            We collaborate with industry leaders to deliver cutting-edge solutions. 
            Together, we're shaping the future of technology and innovation.
          </p>
          
          {/* Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 max-w-4xl mx-auto">
            {stats.map((stat, index) => (
              <div key={index} className="group">
                <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1">
                  <div className="flex items-center justify-center mb-3">
                    <div className={`w-12 h-12 rounded-xl bg-gradient-to-r ${stat.color.includes('blue') ? 'from-blue-500 to-cyan-500' : stat.color.includes('emerald') ? 'from-emerald-500 to-teal-500' : stat.color.includes('amber') ? 'from-amber-500 to-orange-500' : 'from-purple-500 to-pink-500'} flex items-center justify-center group-hover:scale-110 transition-transform duration-300`}>
                      <stat.icon className="w-6 h-6 text-white" />
                    </div>
                  </div>
                  <div className={`text-2xl font-bold ${stat.color} mb-1`}>{stat.number}</div>
                  <div className="text-gray-600 text-sm font-medium">{stat.label}</div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Main Partners Grid */}
        {/* <div className="mb-16">
          <h3 className="text-2xl font-bold text-center text-gray-800 mb-8">Featured Partners</h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 max-w-6xl mx-auto">
            {partners.slice(0, 8).map((partner, index) => (
              <div
                key={index}
                className="group relative bg-white rounded-3xl p-6 shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-3 hover:scale-105 cursor-pointer"
                onMouseEnter={() => setHoveredPartner(index)}
                onMouseLeave={() => setHoveredPartner(null)}
              >
                
                <div className={`absolute inset-0 bg-gradient-to-r ${partner.gradient} opacity-0 group-hover:opacity-10 transition-opacity duration-500 rounded-3xl`}></div>
                
                
                <div className="relative z-10 text-center">
                  
                  <div className={`w-16 h-16 mx-auto mb-4 rounded-2xl bg-gradient-to-r ${partner.gradient} flex items-center justify-center text-white font-bold text-lg shadow-lg group-hover:scale-110 group-hover:rotate-3 transition-all duration-300`}>
                    {partner.logo}
                  </div>
                  
                  
                  <h4 className="font-bold text-gray-900 text-lg mb-1 group-hover:text-blue-600 transition-colors duration-300">
                    {partner.name}
                  </h4>
                  <p className="text-gray-500 text-sm mb-3">{partner.category}</p>
                  
                  
                  <div className={`transition-all duration-300 overflow-hidden ${hoveredPartner === index ? 'max-h-20 opacity-100' : 'max-h-0 opacity-0'}`}>
                    <p className="text-gray-600 text-xs leading-relaxed">
                      {partner.description}
                    </p>
                  </div>
                </div>

                
                <div className="absolute top-3 right-3 w-2 h-2 bg-blue-400 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
              </div>
            ))}
          </div>
        </div> */}

        {/* Infinite Scrolling Partner Logos */}
        <div className="mb-16">
          {/* <h3 className="text-2xl font-bold text-center text-gray-800 mb-8">All Our Partners</h3> */}
          {/* <div className="relative overflow-hidden">
            <div className="flex animate-scroll space-x-8"> */}
              {/* First set */}
              {/* {partners.map((partner, index) => (
                <div
                  key={index}
                  className="flex-shrink-0 w-24 h-24 bg-white rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-110 flex items-center justify-center group cursor-pointer"
                >
                  <div className={`w-16 h-16 rounded-xl bg-gradient-to-r ${partner.gradient} flex items-center justify-center text-white font-semibold text-sm group-hover:rotate-6 transition-transform duration-300`}>
                    {partner.logo}
                  </div>
                </div>
              ))} */}
              {/* Duplicate set for seamless loop */}
              {/* {partners.map((partner, index) => (
                <div
                  key={`duplicate-${index}`}
                  className="flex-shrink-0 w-24 h-24 bg-white rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 transform hover:scale-110 flex items-center justify-center group cursor-pointer"
                >
                  <div className={`w-16 h-16 rounded-xl bg-gradient-to-r ${partner.gradient} flex items-center justify-center text-white font-semibold text-sm group-hover:rotate-6 transition-transform duration-300`}>
                    {partner.logo}
                  </div>
                </div>
              ))}
            </div>
          </div> */}
        </div>


        <div>
  <div className="p-0">
    <div className="overflow-hidden relative h-[100px]">
      <div
        className="flex items-center absolute"
        ref={scrollRef}
      >
        {doubledPartners.map((partner, index) => (
          <div
            key={`${partner.id}-${index}`}
            className="mx-4 flex flex-col items-center"
          >
            <img
              src={partner.logo}
              alt={`${partner.name} logo`}
              className="mt-2 max-h-[50px] object-contain"
            />
            <span
              className="mt-2 text-center font-bold whitespace-nowrap min-w-[140px] font-[Poppins]"
            >
              {/* {partner.name} */}
            </span>
          </div>
        ))}
      </div>
    </div>
  </div>
</div>


        {/* Partnership Benefits */}
        {/* <div className="bg-gradient-to-r from-blue-600 to-purple-600 rounded-3xl p-8 md:p-12 text-white relative overflow-hidden"> */}
          {/* Background decoration */}
          {/* <div className="absolute top-0 right-0 w-40 h-40 bg-white bg-opacity-10 rounded-full -translate-y-20 translate-x-20"></div>
          <div className="absolute bottom-0 left-0 w-32 h-32 bg-white bg-opacity-5 rounded-full translate-y-16 -translate-x-16"></div>
          
          <div className="relative z-10 text-center">
            <h3 className="text-3xl md:text-4xl font-bold mb-6">
              Why Partner With Us?
            </h3>
            <div className="grid md:grid-cols-3 gap-8 max-w-4xl mx-auto">
              <div className="group">
                <div className="w-16 h-16 bg-white bg-opacity-20 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                  <Globe className="w-8 h-8 text-white" />
                </div>
                <h4 className="text-xl font-semibold mb-3">Global Reach</h4>
                <p className="text-blue-100 leading-relaxed">
                  Access worldwide markets through our extensive partner network
                </p>
              </div>
              <div className="group">
                <div className="w-16 h-16 bg-white bg-opacity-20 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                  <Star className="w-8 h-8 text-white" />
                </div>
                <h4 className="text-xl font-semibold mb-3">Innovation</h4>
                <p className="text-blue-100 leading-relaxed">
                  Collaborate on cutting-edge technologies and solutions
                </p>
              </div>
              <div className="group">
                <div className="w-16 h-16 bg-white bg-opacity-20 rounded-2xl flex items-center justify-center mx-auto mb-4 group-hover:scale-110 transition-transform duration-300">
                  <TrendingUp className="w-8 h-8 text-white" />
                </div>
                <h4 className="text-xl font-semibold mb-3">Growth</h4>
                <p className="text-blue-100 leading-relaxed">
                  Accelerate business growth with strategic partnerships
                </p>
              </div>
            </div>
            <button className="mt-8 bg-white text-blue-600 hover:text-blue-700 font-semibold px-8 py-4 rounded-full transition-all duration-300 transform hover:scale-105 inline-flex items-center space-x-2 shadow-lg hover:shadow-xl">
              <span>Become a Partner</span>
              <ArrowRight className="w-5 h-5" />
            </button>
          </div>
        </div> */}
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        
        .animate-scroll {
          animation: scroll 30s linear infinite;
        }
        
        .animate-scroll:hover {
          animation-play-state: paused;
        }
      `}</style>
    </section>
  );
}